'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.PageLayout = void 0

var _react = _interopRequireWildcard(require('react'))

var _reactDiv100vh = _interopRequireDefault(require('react-div-100vh'))

var _reactHelmet = require('react-helmet')

var _reactRouterDom = require('react-router-dom')

var _semanticUiReact = require('semantic-ui-react')

var _styledComponents = _interopRequireWildcard(require('styled-components'))

var _index = require('../../atoms/Typography/index.js')

var _index2 = require('../../molecules/Flex/index.js')

var _templateObject, _templateObject2

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var MENU_ITEMS = [
  {
    label: 'Dashboard',
    route: '/',
  },
]

var PageLayout = function PageLayout(props) {
  var children = props.children,
    title = props.title,
    description = props.description,
    userName = props.userName,
    removeHeader = props.removeHeader,
    removeMargin = props.removeMargin,
    signOut = props.signOut
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext)
  var renderFooter = (0, _react.useMemo)(function () {
    return /*#__PURE__*/ _react['default'].createElement(
      _semanticUiReact.Segment,
      {
        inverted: true,
        vertical: true,
        style: {
          backgroundColor: '#FFF',
        },
      },
      /*#__PURE__*/ _react['default'].createElement(
        _semanticUiReact.Container,
        {
          textAlign: 'center',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _semanticUiReact.List,
          {
            horizontal: true,
            inverted: true,
            divided: true,
            link: true,
            size: 'small',
          },
          /*#__PURE__*/ _react['default'].createElement(
            _semanticUiReact.List.Item,
            {
              as: 'a',
              href: '#',
            },
            /*#__PURE__*/ _react['default'].createElement(
              _index.Typography,
              {
                as: 'h4',
                color: 'primary',
              },
              'Contact Us'
            )
          ),
          /*#__PURE__*/ _react['default'].createElement(
            _semanticUiReact.List.Item,
            {
              as: 'a',
              href: '#',
            },
            /*#__PURE__*/ _react['default'].createElement(
              _index.Typography,
              {
                as: 'h4',
                color: 'primary',
              },
              'Terms and Conditions'
            )
          ),
          /*#__PURE__*/ _react['default'].createElement(
            _semanticUiReact.List.Item,
            {
              as: 'a',
              href: '#',
            },
            /*#__PURE__*/ _react['default'].createElement(
              _index.Typography,
              {
                as: 'h4',
                color: 'primary',
              },
              'Privacy Policy'
            )
          )
        )
      )
    )
  }, [])
  var renderMenu = (0, _react.useMemo)(
    function () {
      return /*#__PURE__*/ _react['default'].createElement(
        StickyMenu,
        {
          fixed: 'top',
          inverted: true,
          style: {
            backgroundColor: '#FFF',
          },
        },
        /*#__PURE__*/ _react['default'].createElement(
          _semanticUiReact.Container,
          null,
          /*#__PURE__*/ _react['default'].createElement(
            _semanticUiReact.Menu.Item,
            {
              as: 'a',
              header: true,
            },
            /*#__PURE__*/ _react['default'].createElement(_semanticUiReact.Image, {
              size: 'small',
              src: theme === null || theme === void 0 ? void 0 : theme.logo,
              style: {
                marginRight: '1.5em',
              },
            })
          ),
          MENU_ITEMS.map(function (_ref, idx) {
            var label = _ref.label,
              route = _ref.route
            return /*#__PURE__*/ _react['default'].createElement(
              _semanticUiReact.Menu.Item,
              {
                key: idx,
                as: _reactRouterDom.Link,
                to: route,
              },
              /*#__PURE__*/ _react['default'].createElement(
                _index.Typography,
                {
                  as: 'h4',
                  color: 'primary',
                },
                label
              )
            )
          }),
          /*#__PURE__*/ _react['default'].createElement(
            StyledDropdown,
            {
              item: true,
              simple: true,
              text: userName,
              float: 'right',
            },
            /*#__PURE__*/ _react['default'].createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Header,
                null,
                /*#__PURE__*/ _react['default'].createElement(
                  _index.Typography,
                  {
                    as: 'h4',
                    color: 'primary',
                  },
                  'User Info'
                )
              ),
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  as: 'a',
                  href: '/profile',
                },
                'Profile'
              ),
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  onClick: function onClick() {
                    return signOut && signOut()
                  },
                },
                'Logout'
              ),
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  onClick: function onClick() {
                    return alert('TODO show settings modal')
                  },
                },
                'Settings'
              ),
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Divider,
                null
              ),
              /*#__PURE__*/ _react['default'].createElement(
                _semanticUiReact.Dropdown.Item,
                null,
                'List Item'
              )
            )
          )
        )
      )
    },
    [signOut, theme, userName]
  )
  return /*#__PURE__*/ _react['default'].createElement(
    _reactDiv100vh['default'],
    {
      style: {
        width: '100vw',
        height: '100rvh',
        padding: 0,
        margin: 0,
      },
    },
    /*#__PURE__*/ _react['default'].createElement(
      _index2.Flex,
      {
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        alignItems: 'center',
      },
      /*#__PURE__*/ _react['default'].createElement(
        _reactHelmet.Helmet,
        null,
        /*#__PURE__*/ _react['default'].createElement('title', null, title || 'Section Name'),
        /*#__PURE__*/ _react['default'].createElement('meta', {
          name: 'description',
          content: description,
        })
      ),
      !removeHeader && renderMenu,
      /*#__PURE__*/ _react['default'].createElement(
        _index2.Flex,
        {
          width: removeMargin ? '100%' : '90%',
          maxWidth: removeMargin ? '100%' : '1200px',
          margin: removeMargin ? '' : '3 0 0 0',
          flex: '1',
          flexDirection: 'column',
        },
        children
      ),
      renderFooter
    )
  )
}

exports.PageLayout = PageLayout
var StickyMenu = (0, _styledComponents['default'])(_semanticUiReact.Menu)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  position: sticky !important;\n  top: 0 !important;\n',
    ]))
)
var StyledDropdown = (0, _styledComponents['default'])(_semanticUiReact.Dropdown)(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  color: ',
      ' !important;\n  font-size: 15px !important;\n  font-weight: bold !important;\n',
    ])),
  function (props) {
    return props.theme.colors.primary
  }
)
